import React from "react";
import bays from "../../Artifacts/scvpu/zoneDashboard/iconbays.svg";

export default function ProgressCard({ title, total = 0, segments = [] }) {
  const formatNumber = (num) => num?.toLocaleString("en-IN");

  return (
    <div className="bg-white rounded-[12px] border border-gray-100 shadow-sm p-2 flex flex-col h-full font-sans">
      {/* Title */}
      <div className=" ml-2 flex items-center gap-3 mb-4">
        <div className="">
          <img alt="icon" className="w-6 h-6 opacity-80" src={bays} />
        </div>
        <h3 className="font-semibold text-[#505050] text-sm">{title}</h3>
      </div>

      {/* Totals & Progress Bar Area */}
      <div className="mt-2">
        <div className="flex justify-between items-end mb-2">
          {/* Left Large Total */}
          <div className="flex flex-col">
            <p className="text-[15px] text-gray-500 font-medium mb-1">Total Active</p>
            <p className="text-[20px] font-bold text-[#333] leading-none tracking-tight">{formatNumber(total)}</p>
          </div>
          
          {/* Right Small Total */}
          <div className="flex items-baseline gap-1 relative top-1">
            <span className="text-[14px] font-semibold text-[#333]">{formatNumber(total)}</span>
            <span className="text-[12px] text-gray-500 font-medium">Total</span>
          </div>
        </div>

        {/* Progress Bar */}
        <div className="w-full bg-gray-100 rounded-full h-[12px] overflow-hidden flex ">
          {segments.map((seg, index) => {
            const percent = total ? (seg.value / total) * 100 : 0;
            return (
              <div
                key={index}
                className="h-full transition-all duration-500"
                style={{
                  width: `${percent}%`,
                  backgroundColor: seg.color,
                }}
              />
            );
          })}
        </div>

        {/* Legends */}
        <div className="flex items-center justify-center  gap-5 w-full ">
          {segments.map((seg, index) => (
            <React.Fragment key={index}>
              <div className="flex items-center mt-5 gap-3">
                <div 
                  className="w-3 h-3 rounded-full" 
                  style={{ backgroundColor: seg.color }}
                />
                <span className="text-[10px] text-gray-500 uppercase tracking-wider">{seg.label}</span>
                <span className="text-sm font-medium text-[#333]">{formatNumber(seg.value)}</span>
              </div>
              
              {/* Vertical divider */}
              {index < segments.length - 1 && (
                <div className="w-px h-8 bg-gray-300 shrink-0" />
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
}
